import { useState } from "react";
import CampaignIndex from "../../components/settings/campaign/campaignField";
import CampaignMapping from "../../components/settings/campaign/campaignMapping/CampaignMapping";
import CampaignRouting from "../../components/settings/campaign/campaignRouting/CampaignRouting";
import LeadUpload from "../../components/settings/campaign/leadUpload/LeadUpload";
import CampaignCreation from "../../components/settings/campaign/campaignCreation/CampaignCreation";
import { useUpgradeModal } from "../../context/UpgradeModalContext";
import CampaignWorkFlow from "../../components/settings/campaign/workflow";
const CampaignSetting = () => {
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
  const { openUpgradeModal } = useUpgradeModal();
  const planName = localStorage.getItem("planName") || "";
  const isFree = planName === "Free";
  const isFreemium = planName === "Freemium";
  const isPaid = !isFree && !isFreemium;

  const tabTitles = [
    "Campaign creation",
    "Workflow",
    "Campaign mapping",
    "Campaign field",
    "Campaign routing",
    "Lead upload",

  ];

  const mappingObj = {
    0: <CampaignCreation />,
    1: <CampaignWorkFlow />,
    2: <CampaignMapping />,
    3: <CampaignIndex />,
    4: <CampaignRouting />,
    5: <LeadUpload />,

  };

 const handleTabClick = (index: number) => {
  // Check if the tab is restricted for the current plan
  if (
    (isFree && [4, 6, 7].includes(index)) || // Free plan restrictions
    (isFreemium && [6, 7].includes(index))    // Freemium plan restrictions (only restrict Order/Invoice mapping and fields)
  ) {
    openUpgradeModal();
    return;
  }
  setActiveTabIndex(index);
};

// Check if a tab is disabled for the current plan
const isTabDisabled = (index: number) => {
  if (isPaid) return false;
  if (isFreemium) return [6, 7].includes(index); // Only disable Order/Invoice mapping and fields for Freemium
  return [4, 6, 7].includes(index); // Disable Campaign routing, Order/Invoice mapping, and fields for Free
};
  return (
    <div className="text-start">
      <div>
        <ul className="nav nav-stretch nav-line-tabs text-primary border-transparent d-flex flex-nowrap mb-5">
          {tabTitles.map((title, index) => {
            const disabled = isTabDisabled(index);
            return (
              <li className="nav-item" key={index}>
                <span
                  style={{
                    textAlign: "center",
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1,
                  }}
                  className={`nav-link fs-4 fw-bold ${
                    activeTabIndex === index ? "active fw-bolder" : ""
                  } ${disabled ? 'text-muted' : ''}`}
                  onClick={() => handleTabClick(index)}
                  role="tab"
                >
                  {title}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      {mappingObj[activeTabIndex]}
    </div>
  );
};

export default CampaignSetting;